import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { FlowFieldLineageLabelsQuery, LabelFragment } from '../../../../../../../gen-src/queries';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function useFlowFieldLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, document }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const [fire, { loading, error, data }] = useLazyQuery<FlowFieldLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { id: item.contentId ?? null } }) }, [fire, item]);

  const labelsContainer: LabelFragment[] = [];
  data?.items.forEach(outputField => {
    if (outputField.field && 'upstreamColumns' in outputField.field) {
      labelsContainer.push(...outputField.field.upstreamColumns.flatMap(c => c? c.labels : []));
    }
  });

  const upstreamLabels: LabelFragment[] | undefined = labelsContainer.length > 0 ? labelsContainer : undefined;

  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream }) };
  return [invoke, result]
}
